/**
 * SF-4746: on someone else's build (opened from All demos) every action is hidden; this says whose
 * it is and why nothing can be done here.
 */
import { Alert } from 'antd';
import type { DemoBuildCreator } from '../api/demoBuildsClient';
import { startedBy } from '../constants';

export const ReadOnlyNote: React.FC<{ creator: DemoBuildCreator | null }> = ({ creator }) => (
  <Alert
    type="info"
    showIcon
    data-testid="read-only-note"
    message={`Started by ${startedBy(creator)}`}
    description="You can read this demo. Only the person who started it can act on it."
  />
);
